/* eslint-disable max-len */
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as api from "../../services/social.service";
import {
  ICreateCommentPayload,
  ICreatePostPayload,
  IDeletePostPayload,
  IGetCommentsPayload,
  IGetNotificationsPayload,
  IGetPostByIdPayload,
  IGetPostsPayload,
  IGetRepliesPayload,
  IReactToPostPayload,
} from "../../models/social.model";

export const createPostThunk = createAsyncThunk(
  "social/createPost",
  async (payload: ICreatePostPayload, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("content", payload.content);
      payload.media.forEach((file, index) => {
        formData.append(`media`, file);
      });
      formData.append("countryCode", payload.countryCode);

      const response = await api.createPost(formData);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const getPostsThunk = createAsyncThunk(
  "social/getPosts",
  async (payload: IGetPostsPayload, { rejectWithValue }) => {
    try {
      const response = await api.getPosts(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const getPostStatsThunk = createAsyncThunk(
  "social/getPostStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getPostStats();
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const getCommentsThunk = createAsyncThunk(
  "social/getComments",
  async (payload: IGetCommentsPayload, { rejectWithValue }) => {
    try {
      const response = await api.getComments(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const createCommentThunk = createAsyncThunk(
  "social/createComment",
  async (payload: ICreateCommentPayload, { rejectWithValue }) => {
    try {
      const response = await api.createComment(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const getRepliesThunk = createAsyncThunk(
  "social/getReplies",
  async (payload: IGetRepliesPayload, { rejectWithValue }) => {
    try {
      const response = await api.getReplies(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const reactToPostThunk = createAsyncThunk(
  "social/reactToPost",
  async (payload: IReactToPostPayload, { rejectWithValue }) => {
    try {
      const response = await api.reactToPost(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const getNotificationsThunk = createAsyncThunk(
  "social/getNotifications",
  async (payload: IGetNotificationsPayload, { rejectWithValue }) => {
    try {
      const response = await api.getNotifications(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const deletePostThunk = createAsyncThunk(
  "social/deletePost",
  async (payload: IDeletePostPayload, { rejectWithValue }) => {
    try {
      const response = await api.deletePost(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const getPostByIdThunk = createAsyncThunk(
  "social/getPostById",
  async (payload: IGetPostByIdPayload, { rejectWithValue }) => {
    try {
      const response = await api.getPostById(payload);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);
